import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const Divider = ({ bullet, horizontal, classes }) => {
    if (bullet) {
        return <div className={classes.bullet} />;
    }
    if (horizontal) {
        return <div className={classes.horizontal} />;
    }
    return <div className={classes.vertical} />;
};

Divider.propTypes = {
    bullet: PropTypes.bool,
    horizontal: PropTypes.bool,
    vertical: PropTypes.bool,
};

Divider.defaultProps = {
    bullet: false,
    horizontal: false,
    vertical: false,
};

const style = ({ spacing, divider }) => ({
    bullet: {
        borderRadius: '50%',
        backgroundColor: divider.bulletBackground,
        width: spacing.unit / 2,
        height: spacing.unit / 2,
        flexShrink: 0,
        margin: {
            left: spacing.unit,
            right: spacing.unit,
        },
    },
    vertical: {
        height: spacing.unit * 4,
        border: divider.verticalBorder,
        margin: {
            top: 0,
            left: spacing.unit,
            bottom: 0,
            right: spacing.unit,
        },
    },
    horizontal: {
        width: '100%',
        borderBottom: divider.horizontalBorder,
    },
});

export default injectSheet(style)(Divider);



// WEBPACK FOOTER //
// ./src/components/Divider.js